import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import PropTypes from 'prop-types'

const ConfirmNoSports = ({ clubName, isOpen, cancelToggle, continueToggle}) => (
  <Modal isOpen={isOpen} toggle={cancelToggle} >
     <ModalHeader toggle={cancelToggle}> Bevestig lidmaatschap</ModalHeader>
     <ModalBody>
       <p>
         Je hebt geen activiteiten gekozen bij Lidmaatschap. Weet je zeker dat je als niet-spelend lid wilt worden aangemeld bij {clubName}?
       </p>
     </ModalBody>
     <ModalFooter>
       <Button color="secondary" onClick={cancelToggle} > Aanpassen </Button>{' '}
       <Button color="primary" onClick={continueToggle} > Aanmelden als niet-spelend lid </Button>{' '}
     </ModalFooter>
   </Modal>
 )

 ConfirmNoSports.propTypes = {
   clubName: PropTypes.string,
   cancelToggle: PropTypes.func.isRequired,
   continueToggle: PropTypes.func.isRequired,
   isOpen: PropTypes.bool.isRequired,
 }

export default ConfirmNoSports



// WEBPACK FOOTER //
// ./src/registrationform/ConfirmNoSports.jsx